export default function (state, getters, rootState, rootGetters) {
    return rootState.settings.payments.load || state.list.loading;
}